// extracted by mini-css-extract-plugin
export var elevatedFrame = "_2-2";
export var elevatedShell = "_2-1";
export var shell = "_2-0";